import { HYDRATE } from "next-redux-wrapper";
import predefinedReviews from "../helpers/predefined";
import { ActionsReview } from "./actions";

const initialState = {
	data: [],
	meta: {},
	paging: {},
	is_loading: true,
	error: null,
	status: "fetch_init",
	message: "",
};

function storeReview(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeReview };
	case ActionsReview.LOAD_GET_REVIEW:
		return {
			...state,
			meta: {},
			data: [],
			paging: {},
			status: "fetch_loading",
			is_loading: true,
			error: null,
		};
	case ActionsReview.RES_GET_REVIEW:
		return {
			...state,
			meta: action.data.meta || {},
			data: predefinedReviews(action.data.data) || [],
			paging: action.data.pagination,
			status: "fetch_result",
			is_loading: false,
			error: null,
		};
	case ActionsReview.ERR_GET_REVIEW:
		return {
			...state,
			meta: {},
			data: [],
			paging: {},
			status: "fetch_error",
			message: "Error...",
			is_loading: false,
			error: true,
		};
	default:
		return { ...state };

	}

}

export default storeReview;
